import produce from 'immer';
import { ActionsUnion, createAction } from 'utils/actionHelpers';
import moment from 'moment';

export enum ActionTypes {
  PERFORM_LOGIN = 'PERFORM_LOGIN',
  PERFORM_LOGIN_SUCCESS = 'PERFORM_LOGIN_SUCCESS',
  PERFORM_LOGIN_FAILURE = 'PERFORM_LOGIN_FAILURE',

  IS_LOGINED_REQUEST = 'IS_LOGINED_REQUEST',
  IS_LOGINED = 'IS_LOGINED',

  LOGOUT = 'LOGOUT',
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE = 'LOGOUT_FAILURE',

  PROFILE_UPDATE = 'PROFILE_UPDATE',
  PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS',
}

export const initialState = {
  id: undefined,
  email: undefined,
  phonenumber: undefined,
  first_name: undefined,
  second_name: undefined,
  patronymic: undefined,
  role_id: undefined,
  user_active: undefined,
  photo: undefined,
  company: undefined,
  position: undefined,
  shop_cart_id: undefined,
  isAuthenticated: false,
};

export interface IUserData {
  id?: number;
  email?: string;
  phonenumber?: string;
  first_name?: string;
  second_name?: string;
  patronymic?: string;
  role_id?: number;
  user_active?: boolean;
  photo?: string;
  company?: string;
  position?: string;
  shop_cart_id?: number;
  referalCode?: string;
  ref_end_date?: string;
  ref_increase_pct?: number;
}

export const Actions = {
  performLogin: (
    values: { login: string, password: string },
    setStatus: (status: any) => void,
    setSubmitting: (isSubmitting: boolean) => void,
  ) => createAction(ActionTypes.PERFORM_LOGIN, { values, setStatus, setSubmitting }),

  performLoginSuccess: (payload: IUserData) =>
    createAction(ActionTypes.PERFORM_LOGIN_SUCCESS, payload),
  performLoginFailure: () =>
    createAction(ActionTypes.PERFORM_LOGIN_FAILURE),

  loginRequest: () =>
    createAction(ActionTypes.IS_LOGINED_REQUEST),
  loginStatus: (isLogined: boolean, user: IUserData) =>
    createAction(ActionTypes.IS_LOGINED, { isLogined, user }),

  logout: () =>
    createAction(ActionTypes.LOGOUT),
  logoutSuccess: () =>
    createAction(ActionTypes.LOGOUT_SUCCESS),
  logoutFailure: () =>
    createAction(ActionTypes.LOGOUT_FAILURE),

  // changePassword: (payload: { login: string, oldPwd: string, newPwd: string }) =>
  //   createAction(ActionTypes.CHANGE_PASSWORD_REQUEST, payload),

  updateProfile: (
    values: IUserData,
    setSubmitting: (isSubmitting: boolean) => void,
    toggleEditProfile: () => void,
  ) =>
    createAction(ActionTypes.PROFILE_UPDATE, { values, setSubmitting, toggleEditProfile }),
  updateProfileSuccess: (payload: IUserData) =>
    createAction(ActionTypes.PROFILE_UPDATE_SUCCESS, payload),
};

export type IUserState = IUserData & {
  isAuthenticated: boolean;
};

export type UserAction = ActionsUnion<typeof Actions>;

export default (state: IUserState = initialState, action: UserAction) =>
  produce(state, (draft: IUserState) => {
    switch (action.type) {
      case ActionTypes.PERFORM_LOGIN_SUCCESS:
        draft.id = action.payload.id;
        draft.email = action.payload.email;
        draft.phonenumber = action.payload.phonenumber;
        draft.first_name = action.payload.first_name;
        draft.second_name = action.payload.second_name;
        draft.patronymic = action.payload.patronymic;
        draft.role_id = action.payload.role_id;
        draft.user_active = action.payload.user_active;
        draft.photo = action.payload.photo;
        draft.company = action.payload.company;
        draft.position = action.payload.position;
        draft.shop_cart_id = action.payload.shop_cart_id;
        draft.referalCode = action.payload.referalCode;
        draft.ref_end_date = action.payload.ref_end_date;
        draft.ref_increase_pct = action.payload.ref_increase_pct;
        draft.isAuthenticated = true;
        return;

      case ActionTypes.IS_LOGINED:
        draft.id = action.payload.isLogined ? action.payload.user.id : undefined;
        draft.email = action.payload.isLogined ? action.payload.user.email : undefined;
        draft.phonenumber = action.payload.isLogined ? action.payload.user.phonenumber : undefined;
        draft.first_name = action.payload.isLogined ? action.payload.user.first_name : undefined;
        draft.second_name = action.payload.isLogined ? action.payload.user.second_name : undefined;
        draft.patronymic = action.payload.isLogined ? action.payload.user.patronymic : undefined;
        draft.role_id = action.payload.isLogined ? action.payload.user.role_id : undefined;
        draft.user_active = action.payload.isLogined ? action.payload.user.user_active : undefined;
        draft.photo = action.payload.isLogined ? action.payload.user.photo : undefined;
        draft.company = action.payload.isLogined ? action.payload.user.company : undefined;
        draft.position = action.payload.isLogined ? action.payload.user.position : undefined;
        draft.shop_cart_id = action.payload.isLogined ? action.payload.user.shop_cart_id : undefined;
        draft.referalCode = action.payload.isLogined ? action.payload.user.referalCode : undefined;
        draft.ref_end_date = action.payload.isLogined ? action.payload.user.ref_end_date : undefined;
        draft.ref_increase_pct = action.payload.isLogined ? action.payload.user.ref_increase_pct : undefined;
        draft.isAuthenticated = action.payload.isLogined;
        return;

      case ActionTypes.LOGOUT_SUCCESS:
        draft.id = undefined;
        draft.email = undefined;
        draft.phonenumber = undefined;
        draft.first_name = undefined;
        draft.second_name = undefined;
        draft.patronymic = undefined;
        draft.role_id = undefined;
        draft.user_active = undefined;
        draft.photo = undefined;
        draft.company = undefined;
        draft.position = undefined;
        draft.shop_cart_id = undefined;
        draft.referalCode = undefined;
        draft.ref_end_date = undefined;
        draft.ref_increase_pct = undefined;
        draft.isAuthenticated = false;
        return;

      case ActionTypes.PROFILE_UPDATE_SUCCESS:
        draft.email = action.payload.email;
        draft.phonenumber = action.payload.phonenumber;
        draft.first_name = action.payload.first_name;
        draft.second_name = action.payload.second_name;
        draft.patronymic = action.payload.patronymic;
        draft.photo = action.payload.photo;
        draft.company = action.payload.company;
        draft.position = action.payload.position;
        return;
    }
  });

  /**
   * Доп. % к бонусу для реферала
   */
  export const getRefBonus = (user: IUserData) =>
    user.ref_increase_pct && moment(user.ref_end_date).isAfter(new Date()) ? user.ref_increase_pct : 0;
